import classNames from "classnames";
import React, { PropsWithChildren } from "react";

type CardColor = "default" | "yellow" | "pink";

interface CardProps extends PropsWithChildren {
  /** Changes the cards background colour via the `background--` utility classes*/
  cardColor?: CardColor;
}

export const Card: React.FC<CardProps> = ({
  cardColor = "default",
  children,
}) => {
  const cardClasses = classNames("card", {
    [`background--${cardColor}`]: cardColor !== "default",
  });

  return <section className={cardClasses}>{children}</section>;
};
